module.exports = __webpack_public_path__ + "media/images/avatar-placeholder-3baf7cf8.png";